/* eslint-disable react/prop-types */
import classes from './index.module.css';

export default function ContentPanel({
  title, desc, step, total = 4, children,
}) {
  return (
    <div className={classes.step_content}>
      <div className={classes.step}>
        Step
        {' '}
        <span className={classes.current_step}>{step}</span>
        {' '}
        of
        {' '}
        {total}
      </div>
      <div className={classes.title_step}>{title}</div>
      <div className={classes.description}>{desc}</div>
      {children}
    </div>
  );
}
